import React from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Notice } from '../services/useSellerNotice';

interface VacationNoticeProps {
  notice: Notice;
  titleDate?: string;
  date?: string;
}

const VACATION_NOTICE_CONFIG = {
  IMAGE_URL: 'https://cf.image-farm.s.zigzag.kr/original/mkt/2025/7/22/202507221118580232_35975.png',
  TITLE: '스토어 배송 휴무 안내',
  ZIGZIN_NOTICE: '직진배송은 정상 운영',
  PERIOD_LABEL: '휴가 기간',
  DEFAULT_CONTENT:
    '휴가 기간으로 전화 문의 및 택배 발송이 되지 않습니다. 이 기간 주문에 대해서는 휴가 종료 후 발송 예정이오니 양해 부탁드립니다.',
} as const;

export const VacationNotice: React.FC<VacationNoticeProps> = ({ notice, titleDate, date }) => {
  return (
    <NoticeWrap>
      <Container>
        <VacationCard>
          <Header>
            <HeaderContent>
              <VacationDate variant='Body_18_Bold' color='subBluePrimary'>
                {titleDate}
              </VacationDate>
              <VacationTitle variant='Body_18_Bold' color='textPrimary'>
                {VACATION_NOTICE_CONFIG.TITLE}
              </VacationTitle>
              <ZigzinShippingNotice variant='Body_13_Medium' color='textPrimary'>
                {VACATION_NOTICE_CONFIG.ZIGZIN_NOTICE}
              </ZigzinShippingNotice>
            </HeaderContent>
            <Image src={VACATION_NOTICE_CONFIG.IMAGE_URL} alt='vacation' />
          </Header>

          <VacationRange>
            <Text as='span' variant='Body_13_Medium' color='textSecondary'>
              {VACATION_NOTICE_CONFIG.PERIOD_LABEL}
            </Text>
            <Text as='span' variant='Body_13_Medium' color='statePositivePrimary'>
              {date}
            </Text>
          </VacationRange>

          <Description as='div' variant='Body_13_Regular' color='textSecondary'>
            {notice.content || VACATION_NOTICE_CONFIG.DEFAULT_CONTENT}
          </Description>
        </VacationCard>
      </Container>
    </NoticeWrap>
  );
};

const NoticeWrap = styled.div`
  padding: 16px;
`;

const Container = styled.div`
  border-radius: 6px;
  padding: 0px 12px 12px;
  background-color: ${vars.color.subSkyBlueBackground};
`;

const Image = styled.img`
  position: relative;
  right: -12px;
  width: 130px;
`;

const ZigzinShippingNotice = styled(Text)`
  padding: 8px 0;
`;

const Header = styled.div`
  display: flex;
`;

const HeaderContent = styled.div`
  position: relative;
  top: 30px;
  margin-right: auto;
  margin-left: 12px;
`;

const VacationDate = styled(Text)`
  line-height: 26px;
`;

const VacationTitle = styled(Text)`
  line-height: 26px;
`;

const VacationRange = styled(Text)`
  display: flex;
  gap: 12px;
  border-radius: 6px;
  padding: 11px 12px;
  background-color: ${vars.color.staticWhite};
`;

const VacationCard = styled.div``;

const Description = styled(Text)`
  padding: 16px 12px;
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-all;
`;
